// Bildverarbeitung und -komprimierung
import { v4 as uuidv4 } from 'uuid';
import loadImage from 'blueimp-load-image';

/**
 * EXIF-Ausrichtung korrigieren – ohne Komprimierung oder Größenänderung
 * @param dataUrl Das Bild als Data-URL
 * @returns EXIF-korrigiertes Bild als PNG Data-URL (verlustfrei)
 */
export const compressImage = async (dataUrl: string): Promise<string> => {
  try {
    const loadImageResult = await loadImage(dataUrl, {
      canvas: true,
      orientation: true  // Nur EXIF-Rotation, keine Größenänderung
    });

    if (!loadImageResult.image || !(loadImageResult.image instanceof HTMLCanvasElement)) {
      throw new Error('Fehler beim Laden des Bildes');
    }

    const canvas = loadImageResult.image as HTMLCanvasElement;
    return canvas.toDataURL('image/png'); // Verlustfrei
  } catch (error) {
    console.error('Fehler bei der Bildverarbeitung:', error);
    throw new Error('Die Bildverarbeitung ist fehlgeschlagen');
  }
};

/**
 * Hilfsfunktion zum Generieren eines eindeutigen Dateinamens
 */
export const generateUniqueImageName = (): string => {
  return `image-${uuidv4()}.jpg`;
};

